import React, { useEffect } from 'react';

//阿宝迁移 未整改
export class View extends React.Component {

  constructor(props) {
    super(props);
  }

  getLineClass(className, line) {

    if (!line) return className;
    let lines = null;
    if (line.indexOf(',') == -1) lines = [line];
    else {
      lines = line.split(',');
    }

    lines.forEach((item) => {
      switch (item) {
        case "bottom": className += " bottomLine"; break;
        case "bottomTop5": className += " bottomLine line-top-5"; break;
        case "bottomTop10": className += " bottomLine line-top-10"; break;
        case "bottomTop15": className += " bottomLine line-top-15"; break;
        case "top": className += " topLine"; break;
        case "topTop5": className += " topLine line-top-5"; break;
        case "topBottom5": className += " topLine line-bottom-5"; break;
        case "topBottom10": className += " topLine line-bottom-10"; break;
        case "topBottom15": className += " topLine line-bottom-15"; break;
        case "bottom top":
        case "top bottom": className += " bottomLine topLine"; break;
        default:;
      }
    });

    return className;
  }

  render() {
    let { style, children, onClick, onPress, className, scroll, line } = this.props;
    onClick = onClick || onPress;
    scroll = scroll ? { overflow: "auto" } : null;
    className = className || '';
    className = this.getLineClass(className, line);
    return (
      <div className={className} onClick={onClick ? (e) => { onClick(e); } : null} style={{ display: "flex", flexDirection: (style ? style.flexDirection : "column"), ...style, ...scroll }}>{children}</div>
    );
  }
}

